import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

function Landing() {
  const navigate = useNavigate();
  const [planA, setPlanA] = useState(3100);
  const [planB, setPlanB] = useState(10000);

  const partners = [
    { role: 'Trusted Partner', name: 'Hypto' },
    { role: 'Channel Partner', name: 'Paymitra' },
    { role: 'Sponsorship', name: 'Opencash' },
    { role: 'Payment Digital', name: 'Hypto' },
    { role: 'Skill', name: 'Zetech IT' },
    { role: 'Fund Management', name: 'Growsper' },
    { role: 'Insurance Partner', name: 'Cover Insurance' },
    { role: 'Shopping', name: 'Onmart' },
    { role: 'Growing Up', name: 'Skill Trust' },
    { role: 'Recharge Partner', name: 'Recharge Panda' },
  ];

  const sliderList = [...partners, ...partners];

  const commonBenefits = [
    '₹5 Lakh Super Power Loan',
    '2 Years Free Recharge',
    'Multiple Income Streams',
    'Daily Passive Income',
    'Referral Income',
  ];

  const planBExtra = [
    'Job offers — Zomato, Swiggy, Apna Mart',
    'Free doctor consultation',
    'Free gold coins',
  ];

  useEffect(() => {
    api
      .get('/AdminConfig/plans')
      .then((res) => {
        const plans = res.data?.plans || [];
        const a = plans.find((p) => p.id === 'A');
        const b = plans.find((p) => p.id === 'B');
        if (a?.amount != null) setPlanA(a.amount);
        if (b?.amount != null) setPlanB(b.amount);
      })
      .catch(() => {
        // API fail → default 3100 / 10000
      });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-600 via-blue-700 to-blue-900 text-white">
      <div className="px-5 pt-8 pb-4 text-center max-w-md mx-auto w-full">
        {/* Brand */}
        <div className="mb-5">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-md border border-white/30 shadow-lg mb-3">
            <span className="text-3xl font-black text-yellow-300">K</span>
          </div>
          <h1 className="text-4xl font-black tracking-tight leading-none">
            <span className="text-white">Kuber</span>
            <span className="text-yellow-300">One</span>
          </h1>
          <p className="text-blue-100 text-sm mt-2 font-medium">
            Join Now & Unlock Amazing Benefits
          </p>
          <p className="text-yellow-200 text-xs mt-1 font-semibold">
            Don’t get late — earn more
          </p>
          <div className="mt-3 mx-auto w-12 h-1 rounded-full bg-yellow-300/80"></div>
        </div>

        {/* Plan A | Plan B */}
        <div className="grid grid-cols-2 gap-3 mb-4 text-left">
          {/* Plan A */}
          <div className="bg-white/15 backdrop-blur-md rounded-2xl p-3 border border-white/20 flex flex-col shadow-lg">
            <p className="text-[10px] text-blue-200 font-semibold uppercase tracking-wide">
              Plan A
            </p>
            <p className="text-xl font-black mt-0.5">
              ₹{Number(planA).toLocaleString('en-IN')}
            </p>
            <ul className="mt-2 space-y-1 text-[10px] text-blue-50 flex-1">
              {commonBenefits.map((b) => (
                <li key={b} className="flex gap-1">
                  <span className="text-green-300 shrink-0">✓</span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
            <button
              type="button"
              onClick={() => navigate('/register?plan=A')}
              className="mt-3 w-full bg-white text-blue-700 font-bold py-2 rounded-xl text-xs"
            >
              Join Plan A
            </button>
          </div>

          {/* Plan B — highlight */}
          <div className="bg-yellow-400/20 backdrop-blur-md rounded-2xl p-3 border-2 border-yellow-300 flex flex-col shadow-lg relative">
            <span className="absolute -top-2 right-2 bg-yellow-300 text-blue-900 text-[8px] font-bold px-1.5 py-0.5 rounded-full">
              POPULAR
            </span>
            <p className="text-[10px] text-yellow-200 font-semibold uppercase tracking-wide">
              Plan B
            </p>
            <p className="text-xl font-black mt-0.5 text-yellow-300">
              ₹{Number(planB).toLocaleString('en-IN')}
            </p>
            <ul className="mt-2 space-y-1 text-[10px] text-blue-50 flex-1">
              {commonBenefits.map((b) => (
                <li key={b} className="flex gap-1">
                  <span className="text-green-300 shrink-0">✓</span>
                  <span>{b}</span>
                </li>
              ))}
              {planBExtra.map((b) => (
                <li key={b} className="flex gap-1">
                  <span className="text-yellow-300 font-bold shrink-0">★</span>
                  <span className="text-yellow-100 font-semibold">{b}</span>
                </li>
              ))}
            </ul>
            <button
              type="button"
              onClick={() => navigate('/register?plan=B')}
              className="mt-3 w-full bg-yellow-300 text-blue-900 font-bold py-2 rounded-xl text-xs"
            >
              Join Plan B
            </button>
          </div>
        </div>

        {/* Login */}
        <div className="mb-3">
          <Link
            to="/login"
            className="block w-full border-2 border-white/80 text-white font-bold py-3 rounded-2xl text-center text-base"
          >
            Login
          </Link>
        </div>

        {/* Our Partners */}
        <div className="pb-3">
          <h2 className="text-sm font-bold text-center mb-0.5">Our Partners</h2>
          <p className="text-center text-blue-200 text-[10px] mb-2">
            Trusted companies we work with
          </p>
          <div className="overflow-hidden w-full -mx-5">
            <div className="flex gap-2.5 animate-partner-scroll w-max px-5">
              {sliderList.map((p, i) => (
                <div
                  key={i}
                  className="bg-white/15 backdrop-blur-md rounded-xl px-3 py-2.5 text-center min-w-[120px] shrink-0 border border-white/10"
                >
                  <p className="text-[8px] text-blue-200 uppercase tracking-wide leading-tight">
                    {p.role}
                  </p>
                  <p className="font-bold text-xs mt-1 leading-tight">{p.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;